//父子结构重组
export function buildTree(data) {
  // 创建一个Map来存储ID到节点的映射
  const idToNodeMap = new Map();

  // 遍历数据，构建映射并初始化children数组
  data.forEach(item => {
    idToNodeMap.set(item.id, { ...item, children: [] });
  });

  // 再次遍历数据，构建父子关系
  data.forEach(item => {
    const nodeId = item.id;
    const parentNodeId = item.parentId;
    // 如果parentId存在且对应节点存在，则将该节点添加到父节点的children数组中
    if (parentNodeId !== null && idToNodeMap.has(parentNodeId)) {
      const parentNode = idToNodeMap.get(parentNodeId);
      parentNode.children.push(idToNodeMap.get(nodeId));
    }
    // 否则，该节点是顶级节点（parentId为null或undefined）
  });

  // 定义一个递归函数来排序节点的children
  function sortNodeChildren(node) {
    if (node.children && node.children.length > 0) {
      node.children.sort((a, b) => a.sortOrder - b.sortOrder);
      node.children.forEach(child => {
        sortNodeChildren(child); // 递归排序子节点的子节点
      });
    }
  }

  // 提取顶级节点（parentId为null的节点），并对它们进行排序
  const topLevelNodes = [];
  data.forEach(item => {
    if (item.parentId === null || item.parentId === undefined) { // 考虑parentId可能是undefined的情况
      topLevelNodes.push(idToNodeMap.get(item.id));
    }
  });
  topLevelNodes.sort((a, b) => a.sortOrder - b.sortOrder); // 对顶级节点进行排序

  // 对每个顶级节点的子节点进行排序
  topLevelNodes.forEach(sortNodeChildren);

  return topLevelNodes;
}
  export function debounce(func, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(this, args);
      }, wait);
    };
  }
  export function throttle(func, wait) {
    let timeout = null;
    return function(...args) {
      if (!timeout) {
        timeout = setTimeout(() => {
          timeout = null;
          func.apply(this, args);
        }, wait);
      }
    };
  }
  export function convertToTwoDimArray(arr, rows) {  
    let result = [];   
    
    for (let i = 0; i < arr.length; i++) {  
    let rowIndex = Math.floor(i / rows);  
    if (!result[rowIndex]) {  
        result[rowIndex] = [];  
    }  
    result[rowIndex].push(arr[i]);  
    }  

    return result;  
}